import classNames from 'classnames';
import React from 'react';

import Heading, { THeadingLevels } from '@/components/switchback/Heading/Heading';
import ResponsiveImage, { IImageProps } from '@/components/utility/ResponsiveImage/ResponsiveImage';

import css from './GridColumn.module.css';

interface CSSModule {
  [className: string]: string;
}

type IImageElement = React.ImgHTMLAttributes<HTMLImageElement>;

interface IProps {
  children?: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  containerClassName?: string;
  headingClassName?: string;
  headingLevel?: THeadingLevels;
  tag?: React.ElementType;
  contentTag?: React.ElementType;
  cssModule?: CSSModule;
  imageProps?: IImageElement & IImageProps;
}

const GridColumn = React.forwardRef<HTMLDivElement, IProps>(
  (
    {
      children,
      title = '',
      description,
      containerClassName,
      headingClassName,
      imageProps = {
        alt: '',
        src: '',
        sourceSizes: ['default'],
        cropMode: 'fill',
        className: '',
        width: null,
        height: null,
      },
      headingLevel = 1,
      tag = 'div',
      contentTag = 'p',
      className = null,
      ...attributes
    },
    ref,
  ) => {
    const {
      alt = title,
      src,
      sourceSizes = ['default'],
      cropMode = 'fill',
      className: iconClassName = '',
      width,
      height,
    } = imageProps;

    const renderIcon = () => {
      if (!src) {
        return null;
      }

      if (width && height && src) {
        return (
          <ResponsiveImage
            src={src}
            alt={alt}
            width={width}
            height={height}
            className={iconClassName}
            sourceSizes={sourceSizes}
            cropMode={cropMode}
          />
        );
      }

      return (
        <ResponsiveImage
          src={src}
          alt={alt}
          className={iconClassName}
          sourceSizes={sourceSizes}
          cropMode={cropMode}
        />
      );
    };
    const Tag = tag;
    const Content = contentTag;
    const contentClasses = className ? className : css.content;
    const headingClasses = classNames(headingClassName, css.heading);
    return (
      <Tag {...attributes} ref={ref} className={containerClassName}>
        {renderIcon()}
        <div className={headingClasses}>
          <Heading level={headingLevel}>{title}</Heading>
        </div>

        <Content className={contentClasses}>{description}</Content>
        {children}
      </Tag>
    );
  },
);
GridColumn.displayName = 'GridColumn';

export default GridColumn;
